import { Chapter } from '../../course-structure/models/chapter';

export class CourseContentResponse {

	chapters: Chapter[];

}
